export default "__VITE_ASSET__orYPbRmk__"